/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
/**
 * Based on custom icon example:
 * https://atlassian.design/components/icon/custom-icon/examples
 */

import React, { type FC } from 'react';
import type { NewCoreIconProps } from '@atlaskit/icon/types';
import AssetsSchemaIcon from '@atlaskit/icon-lab/core/assets-schema';

const JsmAssetsSchemasIcon: FC<NewCoreIconProps> = (props) => <AssetsSchemaIcon {...props} />;

export default JsmAssetsSchemasIcon;
